"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _readOnlyError(name) { throw new Error("\"" + name + "\" is read-only"); }

// Document ready
document.addEventListener("DOMContentLoaded", function () {
  // cookie statement
  var ktCookieStatementContainer = document.querySelector("#ktCookieStatementContainer");

  if (ktCookieStatementContainer && ktCookieStatementContainer.length !== null) {
    if (!checkCookieRecord("kt-cookie-statement-key")) {
      document.querySelector("#ktCookieStatement").style.display = "block";
    } // Conset to allow cookies


    var cookiesConsentButton = document.querySelector("#ktCookieStatementConfirm");

    if (cookiesConsentButton && cookiesConsentButton.length !== null) {
      cookiesConsentButton.addEventListener("click", function () {
        setCookieRecord("kt-cookie-statement-key", 1, 10);
        document.querySelector("#ktCookieStatement").style.display = "none";
      });
    }
  }
}); // Nastaví cookie hodnotu dle klíče po zadanou dobu (pro celou cestu /)

function setCookieRecord(cookieName, cookieValue, expirationDaysCount) {
  var date = new Date();
  date.setFullYear(date.getFullYear() + expirationDaysCount);
  document.cookie = cookieName + "=" + cookieValue + "; path=/; expires=" + date.toUTCString();
} // Smaže cookie hodnotu dle klíče po zadanou dobu (pro celou cestu /)


function removeCookieRecord(cookieName) {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  document.cookie = cookieName + '=""; path=/; expires=' + date.toUTCString();
} // Vrátí hodnotu cookie dle klíče


function getCookieRecord(cookieName) {
  var name = cookieName + "=";
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; _readOnlyError("i"), i++) {
    var cookieValue = cookies[i];

    while (cookieValue.charAt(0) == " ") {
      cookieValue = cookieValue.substring(1);
    }

    if (cookieValue.indexOf(name) == 0) {
      return cookieValue.substring(name.length, cookieValue.length);
    }
  }

  return "";
} // Zkontroluje, zda existuje cookie (hodnota dle klíče)


function checkCookieRecord(cookieName) {
  var cookieValue = getCookieRecord(cookieName);

  if (cookieValue != "") {
    return true;
  }

  return false;
} // Odstraní z URL parametr a jeho hodnotu


function removeUrlParameter(parameter) {
  var url = document.location.href;
  var urlParts = url.split("?");

  if (urlParts.length >= 2) {
    var urlBase = urlParts.shift();
    var queryString = urlParts.join("?");
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = queryString.split(/[&;]/g);

    for (var i = parts.length; (_readOnlyError("i"), i--) > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    url = (_readOnlyError("url"), urlBase + "?" + parts.join("&"));
    window.history.pushState("", document.title, url);
  }

  return url;
} // Vrátí hodnotu parametru z URL podle jeho klíče (názvu)
// BUJS #1 – getParameterByName by James Padolsey (http://james.padolsey.com/javascript/bujs-1-getparameterbyname/)


function getUrlParameterValue(key) {
  var match = RegExp("[?&]" + key + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace("/+/g", " "));
} // Vrátí hodnotu parametru z URL podle jeho klíče (názvu)
// add or update query string parameter by Niyaz (http://stackoverflow.com/a/6021027)


function addOrUpdateUrlParameterValue(key, value) {
  var url = window.location.href;
  var regExp = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf("?") !== -1 ? "&" : "?";

  if (url.match(regExp)) {
    window.history.pushState({}, null, url.replace(regExp, "$1" + key + "=" + value + "$2"));
  } else {
    window.history.pushState({}, null, url + separator + key + "=" + value);
  }
}

$(document).ready(function () {
  // Validování formuláře pomocí jQuery globálně na základě data attributu, který vpisován defaulntě KT_Form třídou
  $('[data-validate="jquery"]').submit(function () {
    $(".validator").remove();
    $("#jquery-kt-validator").remove();
    var showNotice = $(this).data("show-notice");
    var validationResult = $(this).formValidation();
    return validationResult;
  });
  $("input.kt-field, textarea.kt-field").click(function () {
    $(this).next("div.validator").remove();
  });
  $("body").on("click", "div.validator", function () {
    $(this).remove();
  });
  $("input").on("input", function () {
    $(this).siblings(".validator").remove();
  });
});

(function ($) {
  /**
   * jQueryś plugin pro validaci KT_Form na straně browseru
   *
   * @author Tomáš Kocifaj
   * @link http://www.ktstudio.cz
   *
   * @returns {Boolean}
   */
  $.fn.formValidation = function () {
    var dataValidators = "validators";
    var isValid = true;
    var methods = {
      validate: function validate(element) {
        var validators = element.data(dataValidators);

        for (var index in validators) {
          var currentValidator = validators[index];
          var validatorFunction = currentValidator.condition;

          if (currentValidator.condition !== "required" && element.val() === "") {
            continue;
          }

          var result = methods[validatorFunction](element.val(), currentValidator.params);

          if (result === false) {
            element.after(methods.errorMsgContent(currentValidator.msg));
            isValid = false;
            return;
          }
        }
      },
      // validační funkce na základě předané hodnoty
      required: function required(value, param) {
        if (value !== "") {
          return true;
        }

        return false;
      },
      integer: function integer(value, param) {
        return value % 1 === 0;
      },
      "float": function float(value, param) {
        var RE = /^-{0,1}\d*\.{0,1}\d+$/;
        return RE.test(value);
      },
      email: function email(value, param) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(value);
      },
      url: function url(value) {
        var regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return regexp.test(value);
      },
      range: function range(value, param) {
        if (!methods["float"](value)) {
          return false;
        }

        var minValue = parseInt(param[0]);
        var maxValue = parseInt(param[1]);

        if (value >= minValue && value <= maxValue) {
          return true;
        }

        return false;
      },
      length: function length(value, param) {
        if (value.length === param) {
          return true;
        }

        return false;
      },
      maxLength: function maxLength(value, param) {
        if (value.length <= param) {
          return true;
        }

        return false;
      },
      minLength: function minLength(value, param) {
        if (value.length >= param) {
          return true;
        }

        return false;
      },
      maxNumber: function maxNumber(value, param) {
        if (!methods["float"](value)) {
          return false;
        }

        value = parseInt(value);

        if (value <= param) {
          return true;
        }

        return false;
      },
      minNumber: function minNumber(value, param) {
        if (!methods["float"](value)) {
          return false;
        }

        value = parseInt(value);

        if (value >= param) {
          return true;
        }

        return false;
      },
      regular: function regular(value, param) {
        var patt = new RegExp(param);
        return patt.test(value);
      },
      // funkce vrátím HTML s chybovou hláškou na základě předané MSG
      errorMsgContent: function errorMsgContent(msg) {
        var html = '<div class="validator">' + '<span class="erorr-s">' + msg + "</span>" + "</div>";
        return html;
      }
    };
    $(this).find("[data-" + dataValidators + "]").each(function () {
      methods.validate($(this));
    });
    return isValid;
  };
})($); // Document ready


document.addEventListener("DOMContentLoaded", function () {
  LazyLoadingInit();
}); // Lazy loading Init

function LazyLoadingInit() {
  var myLazyLoad = new LazyLoad({
    elements_selector: "[data-src], [data-bg]",
    threshold: 400,
    callback_set: function callback_set(el) {
      objectFitImages(el);
    }
  });
  $(document).ajaxComplete(function () {
    myLazyLoad.update();
  });
} // Document ready


document.addEventListener("DOMContentLoaded", function () {
  submitFormOnFakeButton();
  preventDefaultUtil();
  moveToHtmlTargetInit();
}); //Submit form with fake button

function submitFormOnFakeButton() {
  $("#submitButton, .submitButton").click(function () {
    if ($(this).hasClass("disabled")) {
      return false;
    }

    $(this).parents("form").submit();
  });
} //Prevent Default


function preventDefaultUtil() {
  var preventDefaultItems = document.querySelectorAll(".js-prevent-default"),
      i;

  if (preventDefaultItems[0] != undefined) {
    for (i = 0; i < preventDefaultItems.length; ++i) {
      preventDefaultItems[i].addEventListener("click", function (e) {
        e.preventDefault();
      });
    }
  }
} // Funkce pro animované posunutí na prvek v DOM dokumentu


function moveToHtmlTarget(elemnt, topOffset, bottomOffset) {
  var offset = elemnt.offset().top;

  if (topOffset > 0) {
    offset = offset - topOffset;
  }

  if (bottomOffset > 0) {
    offset = offset + bottomOffset;
  }

  $("html, body").animate({
    scrollTop: offset
  }, 1000);
  return this;
}

function moveToHtmlTargetInit() {
  $("[data-kt-target]").click(function () {
    var targetElement = $($(this).data("kt-target"));
    var targetBottomOffset = $(this).data("kt-bottom-offset");
    var targetTopOffset = $(this).data("kt-top-offset");
    moveToHtmlTarget(targetElement, targetTopOffset, targetBottomOffset);
  });
}

(function () {
  stickyContactPerson(); //Up to tablet portrait - up to 991px

  if (window.matchMedia("(min-width: 61.938em)").matches) {
    window.onscroll = function () {
      stickyContactPerson();
    };
  }

  function stickyContactPerson() {
    var anchorBlock = document.getElementById("anchor-block");

    if (!anchorBlock) {
      return;
    }

    var anchorBlockOffsetHeight = anchorBlock.offsetHeight;
    var headerMain = document.querySelector(".header-main");
    var headerMainOffsetHeight = headerMain.offsetHeight;
    var layoutBaseContent = document.querySelector(".layout-base-content");
    var layoutBaseContentOffsetTop = layoutBaseContent.offsetTop;
    var layoutBaseContentOffsetHeight = layoutBaseContent.offsetHeight;
    var anchorBlockOffsetTop = headerMainOffsetHeight + layoutBaseContentOffsetTop;
    var endOfStickyAnchorBlock = anchorBlockOffsetTop + layoutBaseContentOffsetHeight - anchorBlockOffsetHeight;

    if (window.pageYOffset >= endOfStickyAnchorBlock) {
      anchorBlock.classList.remove("is-sticky");
      layoutBaseContent.classList.add("is-flex-end");
    } else {
      if (window.pageYOffset >= anchorBlockOffsetTop) {
        anchorBlock.classList.add("is-sticky");
        layoutBaseContent.classList.remove("is-flex-end");
      } else {
        anchorBlock.classList.remove("is-sticky");
      }
    }
  }
})(); //Document ready


$(function () {// asideNavMobile();
}); //Resize
//Resize

$(window).resize(function () {
  if (window.matchMedia("(min-width: 62em)").matches) {
    asideNavResizeReset();
  }
}); //Functions

function asideNavMobile() {
  $(".widget_categories .widgettitle").click(function () {
    //Up to tablet portrait - up to 991px
    if (window.matchMedia("(max-width: 61.938em)").matches) {
      $(this).closest(".widget_categories").find("ul").stop().slideToggle(300);
      $(this).toggleClass("js-open");
    }
  });
  $(".widget_nav_menu .widgettitle").click(function () {
    //Up to tablet portrait - up to 991px
    if (window.matchMedia("(max-width: 61.938em)").matches) {
      $(".widget_nav_menu > div > ul").stop().slideToggle(300);
      $(this).toggleClass("js-open");
    }
  });
  $(".widget_pages .widgettitle").click(function () {
    //Up to tablet portrait - up to 991px
    if (window.matchMedia("(max-width: 61.938em)").matches) {
      $(".widget_pages > ul").stop().slideToggle(300);
      $(this).toggleClass("js-open");
    }
  }); //Widget categories with select

  $(".widget_categories select").closest(".widget_categories").addClass("widget_categories_select");
  $(".widget_categories select").selectric();
}

function asideNavResizeReset() {
  $(".aside-nav-heading").removeClass("js-open");
  $(".aside-nav nav").removeAttr("style");
  $(".widget ul").removeAttr("style");
} //Document ready


$(function () {
  fakePlaceholder();
}); //Fake placeholder

function fakePlaceholder() {
  var formInputs = document.querySelectorAll(".contact-form-top input"),
      i;

  for (i = 0; i < formInputs.length; ++i) {
    formInputs[i].addEventListener("focusin", function () {
      placeholderSetActive(this);
    }, false);
    formInputs[i].addEventListener("focusout", function () {
      placeholderSetPassive(this);
    }, false);
  }
} //Placeholder set active


function placeholderSetActive(input) {
  input.parentNode.querySelector(".fake-placeholder").classList.add("js-active");
} //Placeholder set passive


function placeholderSetPassive(input) {
  if (input.value === "") {
    input.parentNode.querySelector(".fake-placeholder").classList.remove("js-active");
  }
} // Document ready


document.addEventListener("DOMContentLoaded", function () {
  tablesStyleCorrection();
  videoIframeWrap();
}); //Tables style correction

function tablesStyleCorrection() {
  removeWidthHeight(".entry-content table");
  removeWidthHeight(".entry-content tr");
  removeWidthHeight(".entry-content th");
  removeWidthHeight(".entry-content td");
} //Remove width and height inline style


function removeWidthHeight(selector) {
  var correctedElement = document.querySelectorAll(selector),
      i;

  for (i = 0; i < correctedElement.length; ++i) {
    if (correctedElement[i].style.removeProperty) {
      correctedElement[i].style.removeProperty("width");
    } else {
      correctedElement[i].style.removeAttribute("width");
    }

    if (correctedElement[i].style.removeProperty) {
      correctedElement[i].style.removeProperty("height");
    } else {
      correctedElement[i].style.removeAttribute("height");
    }
  }
} //Video iframe wrap


function videoIframeWrap() {
  var contentIframes = document.querySelectorAll(".entry-content iframe"),
      i;

  for (i = 0; i < contentIframes.length; ++i) {
    var itemSrc = contentIframes[i].getAttribute("src");

    if (itemSrc.indexOf("youtube") != -1) {
      contentIframes[i].classList.add("embed-responsive-item");
      contentIframes[i].removeAttribute("height");
      contentIframes[i].removeAttribute("width");
      var iframeWrap = document.createElement("div");
      iframeWrap.classList.add("embed-responsive", "embed-responsive-16by9");
      contentIframes[i].parentNode.insertBefore(iframeWrap, contentIframes[i]);
      iframeWrap.appendChild(contentIframes[i]);
    }
  }
} // Document ready


document.addEventListener("DOMContentLoaded", function () {
  headerNavButtonClick();
  headerMaskClick();
  headerHeadroom();
});
var headerMain = document.querySelector(".header-main");
var headerNavButton = document.querySelector(".header-nav-button");
var navMain = document.querySelector(".nav-main");
var headerMask = document.querySelector(".header-mask"); //Header nav

function headerNavButtonClick() {
  headerNavButton.addEventListener("click", function () {
    if (!navMain.classList.contains("js-open")) {
      headerNavShow();
      headerMaskShow();
    } else {
      headerNavHide();
      headerMaskHide();
    }

    if (!navMain.classList.contains("js-transition")) {
      navMain.classList.add("js-transition");
    }
  });
}

function headerNavShow() {
  navMain.classList.add("js-open");
  headerNavButton.classList.add("js-open");
  document.body.classList.add("js-no-scroll");
  document.documentElement.classList.add("js-no-scroll");
}

function headerNavHide() {
  navMain.classList.remove("js-open");
  headerNavButton.classList.remove("js-open");
  document.body.classList.remove("js-no-scroll");
  document.documentElement.classList.remove("js-no-scroll");
} //Header Mask


function headerMaskClick() {
  headerMask.addEventListener("click", function () {
    headerNavHide();
    headerMaskHide();
  });
}

function headerMaskShow() {
  headerMask.classList.add("js-active");
}

function headerMaskHide() {
  headerMask.classList.remove("js-active");
} //Header headroom


function headerHeadroom() {
  var headroom = new Headroom(headerMain, {
    offset: 0,
    tolerance: 25
  });
  headroom.init();
} // Document ready
// document.addEventListener("DOMContentLoaded", function() {
//   if ("-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style) {
//     return;
//   }
//
//   if (document.querySelector(".hp-intro-section")) {
//     // warriorAnim();
//     idleState();
//     warriorAnimation();
//   }
// });
// function warriorAnim() {
//   var vikingTrigger = document.querySelector("#viking-trigger");
//   vikingTrigger.mouseIsOver = false;
//   vikingTrigger.armIsRaised = false;
//   vikingTrigger.animationCompleted = true;
//   //Raise arm trigger
//   vikingTrigger.addEventListener("mouseover", function() {
//     vikingTrigger.mouseIsOver = true;
//     setTimeout(function() {
//       if (!vikingTrigger.armIsRaised && vikingTrigger.mouseIsOver && vikingTrigger.animationCompleted) {
//         raiseArmTrigger();
//         vikingTrigger.armIsRaised = true;
//         vikingTrigger.animationCompleted = false;
//         animationCheck();
//       }
//     }, 200);
//   });
//   //Lower arm trigger
//   vikingTrigger.addEventListener("mouseleave", function() {
//     vikingTrigger.mouseIsOver = false;
//     setTimeout(function() {
//       if (vikingTrigger.armIsRaised && !vikingTrigger.mouseIsOver && vikingTrigger.animationCompleted) {
//         resetAll();
//         vikingTrigger.armIsRaised = false;
//         vikingTrigger.animationCompleted = false;
//         animationCheck();
//       }
//     }, 200);
//   });
//   var animTimer;
//   //Animation check
//   function animationCheck() {
//     var animTimer = setTimeout(function() {
//       vikingTrigger.animationCompleted = true;
//       if (vikingTrigger.mouseIsOver && !vikingTrigger.armIsRaised) {
//         raiseArmTrigger();
//         vikingTrigger.armIsRaised = true;
//         vikingTrigger.animationCompleted = false;
//         animationCheck();
//       } else if (!vikingTrigger.mouseIsOver && vikingTrigger.armIsRaised) {
//         resetAll();
//         vikingTrigger.armIsRaised = false;
//         vikingTrigger.animationCompleted = false;
//         animationCheck();
//       }
//     }, 600);
//   }
//   //Animation switchers
//   function raiseArmTrigger() {
//     idleArm.kill();
//     idleShield.kill();
//     //idleCape.kill();
//     raiseArm.play(0);
//     raiseShield.play(0);
//     //raiseCape.play(0);
//   }
//   function resetAll() {
//     raiseArm.kill();
//     raiseShield.kill();
//     //raiseCape.kill();
//     idleArm.play(0);
//     idleShield.play(0);
//     //idleCape.play(0);
//   }
//   //Animations---------------
//   //Arm
//   var raiseArm = new TimelineMax({
//     paused: true
//   });
//   raiseArm
//     .to(".right-arm", 0.6, {
//       rotation: 90,
//       x: -70,
//       y: 170,
//       transformOrigin: "right top",
//       ease: Back.easeInOut
//     })
//     .to(".right-arm", 0.2, {
//       rotation: 91,
//       x: -70,
//       y: 170,
//       transformOrigin: "right top",
//       ease: Power1.easeInOut,
//       yoyo: true,
//       repeat: -1
//     });
//   var idleArm = new TimelineMax({
//     paused: true
//   });
//   idleArm
//     .from(".right-arm", 0.6, {
//       rotation: 90,
//       x: -70,
//       y: 170,
//       transformOrigin: "right top",
//       ease: Power1.easeInOut
//     })
//     .to(".right-arm", 1.3, {
//       rotation: 1.5,
//       x: 0,
//       y: 0,
//       transformOrigin: "right top",
//       ease: Power1.easeInOut,
//       yoyo: true,
//       repeat: -1
//     });
//   //Shield
//   var idleShield = new TimelineMax({
//     paused: true
//   });
//   idleShield
//     .from(".shield", 0.7, {
//       rotation: 7,
//       x: -45,
//       y: -35,
//       transformOrigin: "center",
//       ease: Back.easeInOut
//     })
//     .to(".shield", 1.3, {
//       rotation: 3.5,
//       x: 0,
//       y: -8,
//       transformOrigin: "center",
//       ease: Power1.easeInOut,
//       yoyo: true,
//       repeat: -1,
//       delay: 0.2
//     });
//   var raiseShield = new TimelineMax({
//     paused: true
//   });
//   raiseShield
//     .to(".shield", 0.5, {
//       rotation: 7,
//       x: -45,
//       y: -35,
//       transformOrigin: "center",
//       ease: Back.easeInOut
//     })
//     .to(".shield", 0.4, {
//       rotation: 7.5,
//       x: -46,
//       y: -36,
//       transformOrigin: "center",
//       ease: Power1.easeInOut,
//       yoyo: true,
//       repeat: -1
//     });
//   //Cape
//   var idleCape = new TimelineMax({
//     paused: true
//   });
//   idleCape.to(".cape", 0.8, {
//     rotation: 0.8,
//     x: 1,
//     y: -1,
//     transformOrigin: "top left",
//     ease: Power1.easeInOut,
//     yoyo: true,
//     repeat: -1
//   });
//   var raiseCape = new TimelineMax({
//     paused: true
//   });
//   raiseCape.to(".cape", 0.4, {
//     rotation: 2,
//     x: 1,
//     y: -1,
//     transformOrigin: "top left",
//     ease: Power1.easeInOut,
//     yoyo: true,
//     repeat: -1
//   });
//   //Initial Animations -----------
//   idleArm.play(0.6);
//   idleShield.play(0.7);
//   idleCape.play(0);
// }
// function warriorAnimation() {
//   var warriorInit = document.querySelector(".warrior-shield");
//
//   warriorInit.addEventListener("mouseover", function() {
//     firstState();
//   });
//
//   warriorInit.addEventListener("mouseout", function() {
//     thirdState();
//   });
// }


function idleState() {
  // var warriorInit = document.querySelector(".warrior-shield");
  // var warriorArm = document.querySelector(".warrior-hand");
  var warriorCloak = document.querySelector(".warrior-cloak"); // warriorInit.classList.add("shield-idle");
  // warriorArm.classList.add("hand-idle");

  warriorCloak.classList.add("cloak-idle");
} // function firstState() {
//   var warriorInit = document.querySelector(".warrior-shield");
//   var warriorArm = document.querySelector(".warrior-hand");
//
//   if (warriorInit.classList.contains("shield-transition-back")) {
//     setTimeout(firstState, 100);
//   } else {
//     warriorInit.classList.add("shield-transition");
//     warriorArm.classList.add("warrior-hand-transition");
//     setTimeout(secondState, 400);
//   }
// }
// function secondState() {
//   var warriorInit = document.querySelector(".warrior-shield");
//   var warriorArm = document.querySelector(".warrior-hand");
//
//   warriorInit.classList.add("shield-active");
//   warriorInit.classList.remove("shield-transition");
//   warriorArm.classList.add("warrior-hand-active");
//
//   warriorArm.classList.remove("warrior-hand-transition");
// }
// function thirdState() {
//   var warriorInit = document.querySelector(".warrior-shield");
//   var warriorArm = document.querySelector(".warrior-hand");
//
//   if (warriorInit.classList.contains("shield-active")) {
//     warriorInit.classList.remove("shield-active");
//     warriorInit.classList.add("shield-transition-back");
//     warriorArm.classList.remove("warrior-hand-active");
//     warriorArm.classList.add("warrior-hand-transition-back");
//     setTimeout(lastState, 800);
//   } else {
//     setTimeout(thirdState, 100);
//   }
// }
//
// function lastState() {
//   var warriorInit = document.querySelector(".warrior-shield");
//   var warriorArm = document.querySelector(".warrior-hand");
//
//   warriorInit.classList.remove("shield-transition-back");
//   warriorArm.classList.remove("warrior-hand-transition-back");
// }


var mapItems = document.querySelectorAll(".map-text-item");
mapItems.forEach(function (item) {
  item.addEventListener('click', function () {
    pointVisibility(item);
    activeTrigger(item);
  });
});

function pointVisibility(item) {
  var activs = document.querySelectorAll(".map-text-item");
  var deactivate = false;

  if (!item.classList.contains("--unvisible")) {
    deactivate = true;
  }

  activs.forEach(function (activ) {
    activ.classList.add("--unvisible");
  });

  if (deactivate === false) {
    item.classList.toggle("--unvisible");
  }
}

function activeTrigger(item) {
  var markerID = item.getAttribute('data-id'); //Find the marker from the Array

  centeredMarker(markerID);
}

function centeredMarker(id) {
  for (var i = 0; i < locations.length; i++) {
    if (locations[i].id == id) {
      //Find the marker from Map
      var point = locations[i];
      var lat = point.lat;
      var lng = point.lng;
      var latLng = new google.maps.LatLng(lat, lng);
      map.panTo(latLng);
    }
  }
}

var mapInit = document.querySelector("#map");

if (mapInit) {
  var initMap = function initMap() {
    $lat = 48.984047;
    $lng = 14.472210;
    map = new google.maps.Map(document.getElementById('map'), {
      center: {
        lat: $lat,
        lng: $lng
      },
      zoom: 17,
      options: {
        mapTypeControl: false,
        streetViewControl: false,
        panControl: false,
        rotateControl: false,
        zoomControl: false
      },
      styles: [{
        "featureType": "all",
        "elementType": "geometry",
        "stylers": [{
          "color": "#ffffff"
        }]
      }, {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [{
          "color": "#f5f5f5"
        }]
      }, {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#323f5a"
        }]
      }, {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
          "visibility": "on"
        }]
      }, {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#283452"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [{
          "color": "#ffffff"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#283452"
        }]
      }, {
        "featureType": "transit",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#e4edff"
        }]
      }, {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#bad1ff"
        }]
      }, {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      }]
    });
    $maxWidth = document.documentElement.clientWidth;
    $mapPan1 = 0;
    $mapPan2 = 0;
    map.panBy($mapPan1, $mapPan2);

    for (var i = 0; i < locations.length; i++) {
      createMarker(locations, i);
    }

    function createMarker(locations, i) {
      var item = locations[i];
      var image = {
        url: locations[i].icon,
        scaledSize: new google.maps.Size(40, 40)
      };
      var marker = new google.maps.Marker(_defineProperty({
        icon: image,
        map: map,
        id: item.id,
        className: item.className,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(item.lat, item.lng)
      }, "animation", google.maps.Animation.DROP));
      glocations.push(marker);
      google.maps.event.addListener(marker, 'click', function () {
        var point = this;
        activMarker(point);
      });
    }
  };

  var activMarker = function activMarker(marker) {
    var point = marker;
    var zIndex = 10;
    point.setZIndex(zIndex);
    var markerID = point.id;
    centeredMarker(markerID);
    var selector = "[data-id='" + markerID + "']";
    var activShop = document.querySelector(selector);
    pointVisibility(activShop);
  };

  var map;
  var marker;
  var glocations = [];
  ;
  google.maps.event.addDomListener(window, "load", initMap);
} // Document ready


document.addEventListener("DOMContentLoaded", function () {
  scrollTriggers();
});

function scrollTriggers() {
  var scrollTrigger = document.querySelector(".scroll-trigger");

  if (!scrollTrigger) {
    return;
  } // Button--------------


  scrollTrigger.addEventListener("click", function () {
    var sectionId = this.getAttribute("data-id-section");
    var topOfSection = document.querySelector("#" + sectionId);
    var topOfSectionPx = topOfSection.offsetTop;
    var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

    if (isIE) {
      window.scrollTo(0, topOfSectionPx);
    } else {
      topOfSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  });
} //Document ready


$(function () {
  commentResponse();
  commentResponseCancel();
}); //Functions

function commentResponse() {
  $(".comments-item-reply span").click(function () {
    $("#comment_parent").val($(this).parent(".comments-item-reply").data("comment-id"));
    moveToHtmlTarget($("#commentform"), 90, 0);
    $(".comment-form-quote-notice").remove();
    $("#commentform").prepend('<div class="comment-form-quote-notice"><span>Odpověď na:</span> <span>"' + $(this).closest(".comments-item").find(".comments-item-content p").text().substring(0, 115) + '..."</span><span class="quote-notice-remove"></span></div>');
  });
}

function commentResponseCancel() {
  $(document).on("click", ".quote-notice-remove", function () {
    $(this).parent(".comment-form-quote-notice").remove();
    $("#comment_parent").val(0);
  });
} // Document ready


document.addEventListener("DOMContentLoaded", function () {
  perexHeight();
});

function perexHeight() {
  var perex = document.querySelectorAll(".posts-item-text-perex");
  var perexParagraph = document.querySelectorAll(".posts-item-text-perex p");
  var i;

  for (i = 0; i < perex.length; i++) {
    var perexHeight = perex[i].offsetHeight;
    var perexHeight = perexHeight / 24;
    var perexHeight = Math.floor(perexHeight);
    var perexHeight = perexHeight * 24;
    perexParagraph[i].style.height = perexHeight + "px";
  }
} //Document ready


$(function () {
  if (document.querySelector(".slider-client-section")) {
    SliderInit();
  }
}); //Place slider init

function SliderInit() {
  var slider = tns({
    container: '.slider-client-section-inner',
    items: 1,
    loop: false,
    autoplay: false,
    arrows: true,
    nav: false,
    controlsContainer: "#slider-client-controls",
    mouseDrag: true,
    responsive: {
      768: {
        items: 3
      },
      991: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  });
}

$(function () {
  if (document.querySelector(".video-item")) {
    document.querySelector("[data-video-button]").addEventListener('click', function (e) {
      e.preventDefault();
      var wrapper = document.querySelector(".video-item");
      wrapper.classList.add("video-play");
      videoPlay(wrapper);
    });
  }
});

function videoPlay(wrapper) {
  var video = wrapper.querySelector("video");
  var iframe = wrapper.querySelector("iframe");

  if (video) {
    var src = video.dataset.video;
    video.setAttribute('src', src);
  } else {
    var _src = iframe.dataset.video;
    iframe.setAttribute('src', _src);
  }
}
//# sourceMappingURL=functions.js.map
